import React, { useMemo } from 'react';

import { useRouter } from 'next/navigation';

import { links } from 'components/HeadMenu/config';
import { createTeamPath } from 'global/urlUtils';
import useSearch from 'global/utils/useSearch';

export interface GoToHomeOptions {
  inviteReferral?: string;
  onHome?: (event: React.MouseEvent) => void;
}

interface UseHeaderFunctionsResult {
  goToHome: (event: React.MouseEvent, options: GoToHomeOptions) => void;
  goToHelp: () => void;
  handleNavigation: (item: { url: string }) => void;
  createTeam: () => void;
  searchProps: {
    query: string;
    tags: string[];
    onSearch: (newQuery: string) => void;
    onCommit: (newQuery: string) => void;
    onSelectOption: (newQuery: string) => void;
    resetQuery: (skipRouter?: boolean) => void;
  };
}

const useHeaderFunctions = (): UseHeaderFunctionsResult => {
  const router = useRouter();
  const { onSearch, resetQuery, tags, query } = useSearch();

  const goToHome = (
    event: React.MouseEvent,
    options: GoToHomeOptions = {}
  ): void => {
    resetQuery(true);

    if (options.inviteReferral) {
      event.preventDefault();
      void router.push(`/invite/${options.inviteReferral}?source=share`);
      return;
    }

    if (options.onHome) {
      return options.onHome(event);
    }
  };

  const goToHelp = (): void => {
    void router.push(links.HELP);
  };

  const handleNavigation = (item: { url?: string }): void => {
    if (item.url) {
      void router.push(item.url);
    }
  };

  const createTeam = (): void => {
    void router.push(createTeamPath);
  };

  const searchProps = useMemo(() => {
    return {
      query,
      tags,
      onSearch,
      onCommit: onSearch,
      onSelectOption: onSearch,
      resetQuery,
    };
  }, [query, tags, onSearch, resetQuery]);

  return {
    goToHome,
    goToHelp,
    handleNavigation,
    createTeam,
    searchProps,
  };
};

export default useHeaderFunctions;
